import { render, staticRenderFns } from "./ModalTransferMoney.vue?vue&type=template&id=d780efd6&scoped=true"
import script from "./ModalTransferMoney.vue?vue&type=script&lang=js"
export * from "./ModalTransferMoney.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d780efd6",
  null
  
)

export default component.exports